/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { shift_requests_ClaimRequest } from '../models/shift_requests_ClaimRequest';
import type { shift_requests_DecisionRequest } from '../models/shift_requests_DecisionRequest';
import type { shift_requests_MyShiftRequestsResponse } from '../models/shift_requests_MyShiftRequestsResponse';
import type { shift_requests_OpenShiftListResponse } from '../models/shift_requests_OpenShiftListResponse';
import type { shift_requests_ShiftRequestListResponse } from '../models/shift_requests_ShiftRequestListResponse';
import type { shift_requests_ShiftRequestResponse } from '../models/shift_requests_ShiftRequestResponse';
import type { shift_requests_SwapOfferRequest } from '../models/shift_requests_SwapOfferRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ShiftRequestsService {
    /**
     * List the open shifts the calling employee may claim
     * Open PUBLISHED shifts (no employee) from today on, in the caller's groups (every group for an all_groups employee), with the number of pending claims and the caller's own claim. Never a draft. from and to default to today and today plus 28 days; the span is at most 92 days.
     * @param from First day (YYYY-MM-DD)
     * @param to Last day (YYYY-MM-DD)
     * @returns shift_requests_OpenShiftListResponse OK
     * @throws ApiError
     */
    public static getApiV1EmployeeMeOpenShifts(
        from?: string,
        to?: string,
    ): CancelablePromise<shift_requests_OpenShiftListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/employee/me/open-shifts',
            query: {
                'from': from,
                'to': to,
            },
            errors: {
                400: `Invalid range`,
                401: `Authentication required`,
                403: `No employee record for this account, or no matching module`,
                500: `Failed to list open shifts`,
            },
        });
    }
    /**
     * Claim an open shift
     * The calling employee asks for an open PUBLISHED future shift of one of their groups. The overlap and absence checks of a planner write run against the caller (409 SHIFT_CONFLICT, EMPLOYEE_ABSENT). The group lead of the shift's first group (or an admin) decides; they get a shift_request_received push. A shift the caller cannot see answers 404.
     * @param shiftId Shift id
     * @param body Optional note
     * @returns shift_requests_ShiftRequestResponse Created
     * @throws ApiError
     */
    public static postApiV1EmployeeMeOpenShiftsClaim(
        shiftId: string,
        body?: shift_requests_ClaimRequest,
    ): CancelablePromise<shift_requests_ShiftRequestResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/employee/me/open-shifts/{shiftId}/claim',
            path: {
                'shiftId': shiftId,
            },
            body: body,
            errors: {
                400: `Invalid body`,
                401: `Authentication required`,
                403: `No employee record for this account, or no matching module`,
                404: `Shift not found`,
                409: `SHIFT_NOT_OPEN, SHIFT_REQUEST_EXISTS, SHIFT_CONFLICT or EMPLOYEE_ABSENT`,
                500: `Failed to claim the shift`,
            },
        });
    }
    /**
     * The calling employee's claims, swaps and decisions
     * mine: the caller's claims and offers and the swaps they accepted (shifts from 14 days ago to 90 days ahead). offers_to_me: pending swap offers the caller may accept. to_decide: requests waiting for the caller's decision (the assigned group lead; every pending request for an admin). can_decide is true for an admin or a group lead.
     * @returns shift_requests_MyShiftRequestsResponse OK
     * @throws ApiError
     */
    public static getApiV1EmployeeMeShiftRequests(): CancelablePromise<shift_requests_MyShiftRequestsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/employee/me/shift-requests',
            errors: {
                401: `Authentication required`,
                403: `No employee record for this account, or no matching module`,
                500: `Failed to list shift requests`,
            },
        });
    }
    /**
     * Accept a swap offer
     * A colleague takes a pending swap offer that names them or is open to every visible colleague. The overlap and absence checks run against the caller; offers close 24 hours before the shift starts. The request moves to accepted and waits for the group lead, who gets a shift_request_received push; the holder gets a shift_request_decided push.
     * @param id Request id
     * @returns shift_requests_ShiftRequestResponse OK
     * @throws ApiError
     */
    public static postApiV1EmployeeMeShiftRequestsAccept(
        id: string,
    ): CancelablePromise<shift_requests_ShiftRequestResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/employee/me/shift-requests/{id}/accept',
            path: {
                'id': id,
            },
            errors: {
                401: `Authentication required`,
                403: `No employee record for this account, or no matching module`,
                404: `Request not found`,
                409: `SHIFT_REQUEST_CLOSED, SHIFT_REQUEST_STALE, SWAP_CUTOFF, SHIFT_CONFLICT or EMPLOYEE_ABSENT`,
                500: `Failed to accept the offer`,
            },
        });
    }
    /**
     * Withdraw one of the calling employee's own requests
     * Ends the caller's own pending claim or swap offer (also an accepted swap the lead has not decided). Its workflow item is closed.
     * @param id Request id
     * @returns shift_requests_ShiftRequestResponse OK
     * @throws ApiError
     */
    public static postApiV1EmployeeMeShiftRequestsWithdraw(
        id: string,
    ): CancelablePromise<shift_requests_ShiftRequestResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/employee/me/shift-requests/{id}/withdraw',
            path: {
                'id': id,
            },
            errors: {
                401: `Authentication required`,
                403: `No employee record for this account, or no matching module`,
                404: `Request not found`,
                409: `SHIFT_REQUEST_CLOSED`,
                500: `Failed to withdraw the request`,
            },
        });
    }
    /**
     * Offer one of the calling employee's shifts for a swap
     * The holder offers a PUBLISHED or CONFIRMED shift to one visible colleague (colleague_employee_id) or to every visible colleague. Offers close 24 hours before the shift starts (409 SWAP_CUTOFF). The named colleague, or every visible colleague without an overlapping shift or an absence that day, gets a shift_offer_received push. Someone else's shift answers 404.
     * @param shiftId Shift id
     * @param body Colleague and note
     * @returns shift_requests_ShiftRequestResponse Created
     * @throws ApiError
     */
    public static postApiV1EmployeeMeShiftsSwapOffers(
        shiftId: string,
        body?: shift_requests_SwapOfferRequest,
    ): CancelablePromise<shift_requests_ShiftRequestResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/employee/me/shifts/{shiftId}/swap-offers',
            path: {
                'shiftId': shiftId,
            },
            body: body,
            errors: {
                400: `Invalid body or SWAP_COLLEAGUE_INVALID`,
                401: `Authentication required`,
                403: `No employee record for this account, or no matching module`,
                404: `Shift not found`,
                409: `SWAP_CUTOFF, SHIFT_NOT_SWAPPABLE or SHIFT_REQUEST_EXISTS`,
                500: `Failed to offer the shift`,
            },
        });
    }
    /**
     * List the open claims and swaps of a date range
     * The pending and accepted requests on shifts from from to to (both required, at most 92 days), with names, for the planner's open-shift blocks and swap marks.
     * @param from First day (YYYY-MM-DD)
     * @param to Last day (YYYY-MM-DD)
     * @returns shift_requests_ShiftRequestListResponse OK
     * @throws ApiError
     */
    public static getApiV1ShiftRequests(
        from: string,
        to: string,
    ): CancelablePromise<shift_requests_ShiftRequestListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/shift-requests',
            query: {
                'from': from,
                'to': to,
            },
            errors: {
                400: `Invalid range`,
                401: `Authentication required`,
                403: `No matching module`,
                500: `Failed to list shift requests`,
            },
        });
    }
    /**
     * Approve a claim or an accepted swap
     * The assigned group lead or an admin approves. A claim assigns the open shift to the claimant as CONFIRMED (confirmed by the approver) and supersedes the other claims; the first approved claim wins. A swap moves the shift to the colleague as PUBLISHED, so the colleague confirms it. Pushes go to every employee involved.
     * @param id Request id
     * @param body Optional reason
     * @returns shift_requests_ShiftRequestResponse OK
     * @throws ApiError
     */
    public static postApiV1ShiftRequestsApprove(
        id: string,
        body?: shift_requests_DecisionRequest,
    ): CancelablePromise<shift_requests_ShiftRequestResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/shift-requests/{id}/approve',
            path: {
                'id': id,
            },
            body: body,
            errors: {
                400: `Invalid body`,
                401: `Authentication required`,
                403: `SHIFT_REQUEST_NOT_DECIDER or SHIFT_REQUEST_SELF_DECISION`,
                404: `Request not found`,
                409: `SHIFT_REQUEST_CLOSED, SHIFT_REQUEST_NOT_DECIDABLE, SHIFT_REQUEST_STALE, SHIFT_CONFLICT or EMPLOYEE_ABSENT`,
                500: `Failed to decide the request`,
            },
        });
    }
    /**
     * Reject a claim or an accepted swap
     * The assigned group lead or an admin rejects; an open shift stays open, a swapped shift stays with its holder. The employees involved get a shift_request_decided push.
     * @param id Request id
     * @param body Optional reason
     * @returns shift_requests_ShiftRequestResponse OK
     * @throws ApiError
     */
    public static postApiV1ShiftRequestsReject(
        id: string,
        body?: shift_requests_DecisionRequest,
    ): CancelablePromise<shift_requests_ShiftRequestResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/shift-requests/{id}/reject',
            path: {
                'id': id,
            },
            body: body,
            errors: {
                400: `Invalid body`,
                401: `Authentication required`,
                403: `SHIFT_REQUEST_NOT_DECIDER or SHIFT_REQUEST_SELF_DECISION`,
                404: `Request not found`,
                409: `SHIFT_REQUEST_CLOSED or SHIFT_REQUEST_NOT_DECIDABLE`,
                500: `Failed to decide the request`,
            },
        });
    }
}
